module.exports = __webpack_public_path__ + "img/zzfk.cb00c9e0.png";